import { routes } from "vue-router/auto-routes";
import { createRouter, createWebHistory } from "vue-router";
import { addDefaultMeta } from "@/router/utils";
import { buildLegacyRedirectRoutes } from "@/router/legacyRedirects";
import { scrollBehavior } from "@/router/scrollBehavior";
import { installOverlayPopstateListener } from "@/router/overlayBackGuard";

// Legacy records go last so a renamed path can never shadow a real page.
const routesWithDefaults = addDefaultMeta([...routes, ...buildLegacyRedirectRoutes()]);

// Before createWebHistory(): popstate listeners run in registration order, not capture-first.
installOverlayPopstateListener();

export const router = createRouter({
  history: createWebHistory(),
  routes: routesWithDefaults,
  scrollBehavior,
});
